/** Partner login on the public site (never admin). */
export const PARTNER_PUBLIC_LOGIN_URL = "https://lushgroom.com/login";
